/*  eslint indent : "off" , react/jsx-indent: "off"
*/
import React, { useState } from 'react';
import * as moment from 'moment';
import {
    filterIssues,
    timeStats,
    formatDay,
    getIssueProject,
} from '../../lib/utils';
import { useConf, useTicketFetcher, useProjectNames } from '../../lib/hooks';
import { Spinner } from '../common/Helper';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

const IssueCard = ({ issue }) => {
    const dispatch = useDispatch();
    const cls = classNames('issue-card', {
        'is-closed': issue.state === 'closed',
        'is-unestimated': issue.timeEstimate === null,
    });

    const handleClick = (e) => {
        if (!e.target.href || e.target.href.indexOf('internal://') === -1) {
            return;
        }
        e.preventDefault();
        dispatch({ type: 'show-modal', name: 'issueModal', data: issue.ticketId });
    };
    return (
        <div className={cls} style={{ marginBottom: 'var(--ds-space-2)' }}>
            <a className="issue-card__title" href={issue.url} onClick={handleClick} rel="noreferrer" target="_blank">
                {issue.title}
            </a>
            <div className="issue-tags">
                {issue.labels.map(l => <span key={l} className="issue-tag">{l}</span>)}
                <span
                    className="issue-tag"
                    title="Spent / Estimate"
                    style={{ background: issue.timeSpent > issue.timeEstimate ? 'var(--ds-danger-tint)' : 'var(--ds-success-tint)', color: issue.timeSpent > issue.timeEstimate ? '#9c241a' : '#0f6b3c' }}
                >
                    {timeStats(issue)}
                </span>
                <span className="issue-tag" style={{ background: 'var(--ds-accent-tint)' }}>
                    {moment(issue.dueDate).format('MMM DD')}
                </span>
            </div>
            {issue.assignee && <div className="issue-card__meta" style={{ justifyContent: 'flex-end' }}>{issue.assignee.name}</div>}
        </div>
    );
};

const IssueBoard = (props) => {

    const [swimMode, setSwimMode] = useState('project');
    const [showCards, setShowCards] = useState(true);

    const { workflow: filters } = useConf();
    const { ticketListFiltered } = useTicketFetcher(props.filter)
    const projectNames = useProjectNames();
 

    const modeChange = (e) => {
        setSwimMode(e.target.value);
    }

    const changeCardView = (e) => {
        setShowCards(e.target.checked);
    }


    if (!ticketListFiltered) {
        return <Spinner />
    }

    let swimLanes = { 'Team': ticketListFiltered };

    if (swimMode && swimMode !== 'team' && ticketListFiltered) {
        swimLanes = ticketListFiltered.reduce((acc, issue) => {

            let name = 'UnAssigned';
            if (swimMode === 'project') {
                name = getIssueProject(issue);
            } else if (swimMode === 'user') {
                if (issue.assignee) {
                    name = issue.assignee.name;
                }
            }
            if (!acc[name]) {
                acc[name] = [];
            }
            acc[name].push(issue);
            return acc;
        }, {});
    }

    const headers = [];
    let rows = [];
    let completedCount = 0;
    Object.keys(swimLanes).forEach(name => {
        const cols = []
        let rowTotal = 0;
        let rowSpentTotal = 0;
        const list = filters.map((title, idx) => {
            const list = filterIssues(swimLanes[name], title.toLowerCase());

            const totalTm = list.reduce((acc, i) => acc + i.timeEstimate, 0);
            const totalSpend = list.reduce((acc, i) => acc + i.timeSpent, 0);
            if (title.toLowerCase() === 'closed') {
                completedCount = list.length;
            }

            rowTotal += totalTm;
            rowSpentTotal += totalSpend;
            cols.push(<td key={`col_${idx}`} className="board-col">
                {title}
                <span className="board-col__count">{list.length}</span>
                <span style={{ marginLeft: 'var(--ds-space-2)', color: 'var(--ds-ink-faint)' }}>{formatDay(totalTm)}</span>
            </td>);
            return <td key={`col_${idx}`} className="board-col">
                {list.map(i => <IssueCard key={`card_${i.id}`} issue={i} />)}
            </td>;
        });

        const url = '';
        const nList = [];
        nList.push(<tr className={classNames('board-lane', { 'is-done': completedCount === swimLanes[name].length })} key={name}>
            <td colSpan={filters.length}>
                <a rel="noreferrer" target="_blank" href={url}>{swimMode === 'project' ? (projectNames[name] || name) : name}</a>
                <span className="board-lane__meta">
                    <span>Spent {formatDay(rowSpentTotal)} / E {formatDay(rowTotal)}</span>
                    <span>Tasks {completedCount}/{swimLanes[name].length}</span>
                </span>
            </td>
        </tr>);
        nList.push(<tr className="board-colhead" key={name + "_times"}>{cols}</tr>);
        if (showCards) {
            nList.push(<tr key={name + '_issues'}>{list}</tr>);
        }
        if (completedCount === swimLanes[name].length) {
            rows = rows.concat(nList);
        } else {
            rows = nList.concat(rows);
        }
    });


    return <div className="ds-scope">
        <div className="board-controls">
            <select className="ds-select" style={{ maxWidth: '220px' }} onChange={modeChange} aria-label="Group swimlanes by">
                <option value="project">By project</option>
                <option value="user">By user</option>
                <option value="team">Whole team</option>
            </select>
            <label className="board-check">
                <input checked={showCards} onChange={changeCardView} type="checkbox" /> Show ticket cards
            </label>
        </div>
        <div className="ds-table-wrap">
            <table className="board-table">
                <thead>
                    <tr>{headers}</tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </div>
    </div>;

}


export default IssueBoard;